import BaseObject from '../../../base/base_object';
import {SYSTEM_EVENTS} from '../../../events/events';
import Event from '../../../utils/event';
import DateTimeUtils from '../../../utils/date_time_utils';


export default class LoginTimeAnalytics extends BaseObject {
    static CLASS = 'LoginTimeAnalytics';

    init(params) {
        super.init(params);
        this._action = params.action;
    }

    static forLoginWithPassword() {
        return LoginTimeAnalytics.create({
            action: 'LoginWithPassword'
        });
    }

    static forAutologinWithToken() {
        return LoginTimeAnalytics.create({
            action: 'AutologinWithToken'
        });
    }

    static forAutologinWithTouchId() {
        return LoginTimeAnalytics.create({
            action: 'AutologinWithTouchId'
        });
    }

    _success(duration) {
        Event.once(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
            this._sendAnalytics('Success' + this._action, duration);
        }, this);
    }

    _fail(duration, error) {
        this._sendAnalytics('Fail' + this._action, duration, error && error.error_code);
    }


    measure(callback) {
        let startTime = Date.now();

        let duration = () => {
            return DateTimeUtils.millisecondsToSeconds(Date.now() - startTime);
        };

        return callback().then((data) => {
            this._success(duration());
            return data;
        }).catch(err => {
            this._fail(duration(), err);
            throw err;
        });
    }

    _sendAnalytics(label, duration, errorCode) {
        let analyticsData = {
            category: '[Technical-event]',
            action: 'Login',
            label: label,
            value: duration
        };

        if(errorCode) {
            analyticsData.label += '.' + errorCode;
        }


        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticsData);
    }

}